import { createFileRoute } from '@tanstack/react-router';
import { SubscriptionScreen } from '@/features/subscription/components/subscription-screen';

// Onglet « Abonnement » des réglages — forfait, paiement (Stripe), essai et
// consommation. C'est aussi la destination du paywall (SUBSCRIPTION_INACTIVE).
export const Route = createFileRoute('/_app/settings/subscription')({
  component: SubscriptionScreen,
});
